/* -------------------------------------------------------------------------- *
 * Mobile Header Navigation *
 * -------------------------------------------------------------------------- */

const trigger_el = document.getElementById('js-navToggle');
const target_el = document.getElementById('js-navContent');

// Default state
let toggled = false;

// Show/hide the global navigation
function toggleNav(e) {
    e.preventDefault();

    // Update the display
    trigger_el.classList.toggle('is-toggled');
    target_el.classList.toggle('is-toggled');

    // Swap state
    toggled = !toggled;
}

/* ------------- *
 * Module Export *
 * ------------- */

const Navigation = {
    init() {
        trigger_el.addEventListener('click', toggleNav);
    },
};

export default Navigation;
